import { render, staticRenderFns } from "./AdditionalCharges.vue?vue&type=template&id=5802e3c1&"
import script from "./AdditionalCharges.vue?vue&type=script&lang=js&"
export * from "./AdditionalCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports